import React from "react";
import PageHeader from "../components/PageHeader";

export default function Acts() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Pages", link: "/pages" },
    { label: "Commissions", active: true },
  ];

  const commissions = [
    {
      id: 1,
      title: "प्रथम आयोग",
      period: "31.08.2010 – 31.08.2013",
      members:
        "श्रीमती निशा झा (अध्यक्ष), श्रीमती अपर्णा सिंह (सदस्य), श्रीमती शोभा कुशवाहा (सदस्य), श्रीमती ललिता सिंह (सदस्य), श्री विमल कुमार जैन (सदस्य), श्री शिव शंकर प्रसाद 'निषाद' (सदस्य), डॉ. निशिन्द्र किंजल्क (सदस्य)",
    },
    {
      id: 2,
      title: "द्वितीय आयोग",
      period: "24.02.2014 – 18.05.2016",
      members:
        "श्रीमती निशा झा (अध्यक्ष), श्रीमती अपर्णा सिंह (सदस्य), डॉ. निशिन्द्र किंजल्क (सदस्य), श्रीमती ललिता जायसवाल (सदस्य), श्री सत्येन्द्र कुमार गौतम (सदस्य), मो. हाजी अब्दुल सत्तार (सदस्य), श्री अरुण कुमार वर्मा (सदस्य)",
    },
    {
      id: 3,
      title: "तृतीय आयोग",
      period: "मई 2017 – मई 2020",
      members:
        "डॉ. हरपाल (अध्यक्ष), श्रीमती प्रेमा शाह (सदस्य), श्रीमती उषा देवी (सदस्य), श्रीमती प्रमिला सिंह (सदस्य), श्री विजय कुमार रोशन (सदस्य), श्री पंकज सिन्हा (सदस्य), श्री परमहंस कुमार (सदस्य)",
    },
    {
      id: 4,
      title: "चतुर्थ आयोग",
      period: "मई 2020 – फरवरी 2023",
      members:
        "प्रो. (डॉ.) प्रमिला कुमारी (अध्यक्ष), श्रीमती सुनंदा पांडे (सदस्य)",
    },
    {
      id: 5,
      title: "पंचम आयोग",
      period: "सितंबर 2024 – वर्तमान",
      members:
        "डॉ. अमरदीप (अध्यक्ष), डॉ. हुलेश मांझी (सदस्य), श्रीमती संगीता ठाकुर (सदस्य), डॉ. ज्योति कुमारी (सदस्य), श्रीमती शीला पंडित (सदस्य), डॉ. सुग्रीव दास (सदस्य), श्री राकेश कुमार सिंह (सदस्य)",
    },
  ];

  return (
    <>
      <PageHeader title="Commissions" breadcrumbs={breadcrumbs} />

      <div className="container mx-auto px-4 py-8 chairman-content">
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-8">
          अब तक गठित आयोग
        </h2>
<br/>
        {/* CARD GRID (col-6 style) */}
        <div className="row">
          {commissions.map((item) => (
            <div key={item.id} className="col-12 col-md-6 mb-4">
              <div className="info-block h-100">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">
                  {item.title}
                </h3>

                <p className="text-sm text-gray-600 mb-3">
                  <strong>कार्यकाल:</strong> {item.period}
                </p>

                <p className="text-gray-800 leading-relaxed">
                  <strong>अध्यक्ष एवं सदस्य:</strong>
                  <br />
                  {item.members}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
